module.exports = __webpack_public_path__ + "img/yahoo-20220811.05f5090d.jpg";